module.exports = __webpack_public_path__ + "img/button_questionnaire1@2x.25494b82.png";